'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'flux-capacitor';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8ba';
var svgPathData = ['M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 56c0 30.9 25.1 56 56 56 6.6 0 12.9-1.1 18.8-3.2l61.2 61.2 0 43.4c-18.9 9-32 28.3-32 50.6 0 30.9 25.1 56 56 56s56-25.1 56-56c0-22.3-13.1-41.6-32-50.6l0-43.4 61.2-61.2c5.9 2.1 12.2 3.2 18.8 3.2 30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56c0 6.6 1.1 12.9 3.2 18.8l-51.2 51.2-51.2-51.2c2.1-5.9 3.2-12.2 3.2-18.8 0-30.9-25.1-56-56-56s-56 25.1-56 56z', 'M172.8 170.8c2.1-5.9 3.2-12.2 3.2-18.8 0-30.9-25.1-56-56-56s-56 25.1-56 56 25.1 56 56 56c6.6 0 12.9-1.1 18.8-3.2l61.2 61.2 0 43.4c-18.9 9-32 28.3-32 50.6 0 30.9 25.1 56 56 56s56-25.1 56-56c0-22.3-13.1-41.6-32-50.6l0-43.4 61.2-61.2c5.9 2.1 12.2 3.2 18.8 3.2 30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56c0 6.6 1.1 12.9 3.2 18.8l-51.2 51.2-51.2-51.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFluxCapacitor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;